export default class Simulation {
  constructor(label, attacks, defense, armor, stats) {
    this.label = label;
    this.attacks = attacks;
    this.defense = defense;
    this.armor = armor;
    this.stats = stats;
  }
  get statsAxis() {
    return Object.entries(this.stats).map(([key, value]) =>
      Object.create({ x: key, y: value })
    );
  }
  cumulativeXY() {
    const xs = Object.keys(this.stats);
    const ys = xs.map(key => this.stats[key]);
    ys.pop();
    let accumulatedYs = [];
    ys.reduce((prev, curr, i) => (accumulatedYs[i] = prev - curr), 100);
    accumulatedYs.unshift(100);
    accumulatedYs = accumulatedYs.map(y => (y >= 0.01 ? y.toFixed(2) : 0));
    return [xs, accumulatedYs];
  }
  get cumulativeStatsAxis() {
    const [xs, accumulatedYs] = this.cumulativeXY();
    return xs.map((x, index) => {
      const y = accumulatedYs[index];
      return Object.create({ x: x, y: y });
    });
  }
  get cumulativeStats() {
    const [xs, accumulatedYs] = this.cumulativeXY();
    const res = {};
    xs.forEach((x, index) => (res[x] = accumulatedYs[index]));
    return res;
  }
}
